import _implicitStylesheets from "./formattedUrlCell.css";

import _implicitScopedStylesheets from "./formattedUrlCell.scoped.css?scoped=true";

import _myDependencyModal from "my/dependencyModal";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, d: api_dynamic_text, t: api_text, h: api_element, c: api_custom_element} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    key: 0
  }, [api_element("a", {
    attrs: {
      "href": "#"
    },
    key: 1,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.handleDependencyModal))
    }
  }, [api_text(api_dynamic_text($cmp.label))])]), $cmp.isModalOpen ? api_element("div", {
    key: 2
  }, [api_custom_element("my-dependency-modal", _myDependencyModal, {
    props: {
      "data": $cmp.data,
      "name": $cmp.name,
      "developerName": $cmp.developerName,
      "preSelectedDepRows": $cmp.selectedDependencyRows
    },
    key: 3,
    on: {
      "closemodal": _m1 || ($ctx._m1 = api_bind($cmp.closeDependencyModal))
    }
  }, [])]) : null];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-formattedUrlCell_formattedUrlCell"
